import {
  API_SUCCESS,
  API_FAIL,
  GET_USERS_DATA,
  UPDATE_USER_DATA,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  CLEAR_ERRORS,
  UPDATE_USER,
  DELETE_USER,
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_ADMIN_DASHBOARD_SUMMARY_REQUEST,
  GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS,
  GET_ADMIN_DASHBOARD_SUMMARY_FAILURE,
  GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST,
  GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS,
  GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE,
  GET_ASSESSMENTS_DATA,
  ADD_ASSESSMENT,
  ADD_ASSESSMENT_SUCCESS,
  ADD_ASSESSMENT_FAIL,
  ASSESSMENT_API_FAIL,
  ASSESSMENT_API_SUCCESS,
  UPDATE_SUPER_USER_FAIL,
  UPDATE_SUPER_USER_SUCCESS,
  UPDATE_ASSESSMENT_DATA,
  UPDATE_ASSESSMENT_SUCCESS,
  UPDATE_ASSESSMENT_FAIL,
  STEP_BACK,
  CLEAR_ASSESSMENT_ID,
  STEP_NEXT,
  GO_TO_DASHBOARD,
  CREATE_PATIENT,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAIL,
  GET_PATIENT_DATA,
  GET_PATIENT_DATA_SUCCESS,
  GET_PATIENT_DATA_FAIL,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAIL,
  DELETE_PATIENT,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  CLONE_ASSESSMENT_FAIL,
  CLONE_ASSESSMENT_SUCCESS,
  CLONE_ASSESSMENT,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_DOMAINS_FAILURE,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_REQUEST,
  GET_ME_DASHBOARD_SUMMARY_REQUEST,
  GET_ME_DASHBOARD_DAILY_DOCS_REQUEST,
  GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST,
  GET_ME_DASHBOARD_TOP_TYPES_REQUEST,
} from "./actionTypes"

export const apiSuccess = data => ({
  type: API_SUCCESS,
  payload: data,
})

export const apiFail = error => ({
  type: API_FAIL,
  payload: error,
})

export const getUsersData = (params) => ({
  type: GET_USERS_DATA,
  payload: params,
})


export const createUser = (data, history, getUsersData) => ({
  type: CREATE_USER,
  payload: { data, history, getUsersData },
})

export const createUserSuccess = data => ({
  type: CREATE_USER_SUCCESS,
  payload: data,
})

export const createUserFail = error => ({
  type: CREATE_USER_FAIL,
  payload: error,
})

export const updateUser = (data, history, getUsersData, getUser, userId) => ({
  type: UPDATE_USER,
  payload: { data, history, getUsersData, getUser, userId },
})

export const updateSuccess = data => ({
  type: UPDATE_USER_SUCCESS,
  payload: data,
})

export const updateFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const deleteUser = (history, getUsersData, userId) => ({
  type: DELETE_USER,
  payload: { history, getUsersData, userId },
})

export const deleteUserSuccess = data => ({
  type: DELETE_USER_SUCCESS,
  payload: data,
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})

export const getUser = userId => ({
  type: GET_USER,
  payload: { userId },
})

export const getUserSuccess = data => ({
  type: GET_USER_SUCCESS,
  payload: data,
})

export const getUserFail = error => ({
  type: GET_USER_FAIL,
  payload: error,
})

export const updateUserData = (data, history, getUsersData) => ({
  type: UPDATE_USER_DATA,
  payload: { data, history, getUsersData },
})

export const updateSuperUserSuccess = data => ({
  type: UPDATE_SUPER_USER_SUCCESS,
  payload: data,
})

export const updateSuperUserFail = error => ({
  type: UPDATE_SUPER_USER_FAIL,
  payload: error,
})

export const getDomainsRequest = () => ({
  type: GET_DOMAINS_REQUEST,
})

export const getDomainsSuccess = (domains) => ({
  type: GET_DOMAINS_SUCCESS,
  payload: domains,
})

export const getDomainsFailure = (message) => ({
  type: GET_DOMAINS_FAILURE,
  payload: message,
})

export const getAdminDashboardSummary = (filters = {}) => ({
  type: GET_ADMIN_DASHBOARD_SUMMARY_REQUEST,
  filters,
})

export const getAdminDashboardSummarySuccess = (payload) => ({
  type: GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS,
  payload,
})

export const getAdminDashboardSummaryFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_SUMMARY_FAILURE,
  error,
})

export const getAdminDashboardSignups = (weeks = 12, filters = {}) => ({
  type: GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST,
  weeks,
  filters,
})

export const getAdminDashboardSignupsSuccess = (payload) => ({
  type: GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS,
  payload
})

export const getAdminDashboardSignupsFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE,
  error
})

export const getAdminDashboardDocsMonthly = (year, filters = {}) => ({
  type: GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST,
  year,
  filters,
})

export const getAdminDashboardDocsMonthlySuccess = (payload) => ({
  type: GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS,
  payload
})

export const getAdminDashboardDocsMonthlyFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE,
  error
})

export const getAdminDashboardCompanyTypes = (filters = {}) => ({
  type: GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST,
  filters,
})

export const getAdminDashboardCompanyTypesSuccess = (payload) => ({
  type: GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS,
  payload
})

export const getAdminDashboardCompanyTypesFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE,
  error
})

export const getAdminDashboardActiveSessions = (interval = 20, filters = {}) => ({
  type: GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST,
  interval,
  filters,
})

export const getAdminDashboardActiveSessionsSuccess = (payload) => ({
  type: GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS,
  payload
})

export const getAdminDashboardActiveSessionsFailure = (error) => ({
  type: GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE,
  error
})

export const getMeDashboardSummary = (filters = {}) => ({
  type: GET_ME_DASHBOARD_SUMMARY_REQUEST,
  filters
})

export const getMeDashboardDailyDocs = (filters = {}) => ({
  type: GET_ME_DASHBOARD_DAILY_DOCS_REQUEST,
  filters
})

export const getMeDashboardDocsMonthly = (year, filters = {}) => ({
  type: GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST,
  year, filters
})

export const getMeDashboardTopTypes = (filters = {}) => ({
  type: GET_ME_DASHBOARD_TOP_TYPES_REQUEST,
  filters
})

export const clearErrors = data => ({
  type: CLEAR_ERRORS,
})

export const assessmentapiSuccess = data => ({
  type: ASSESSMENT_API_SUCCESS,
  payload: data,
})

export const assessmentapiFail = error => ({
  type: ASSESSMENT_API_FAIL,
  payload: error,
})

export const getAssessmentsData = () => ({
  type: GET_ASSESSMENTS_DATA,
})

export const addAssessment = (data, history, getAssessmentsData) => ({
  type: ADD_ASSESSMENT,
  payload: { data, history, getAssessmentsData },
})

export const addAssessmentSuccess = data => ({
  type: ADD_ASSESSMENT_SUCCESS,
  payload: data,
})

export const addAssessmentFail = error => ({
  type: ADD_ASSESSMENT_FAIL,
  payload: error,
})

export const updateAssessmentData = (
  data,
  history,
  getAssessmentsData,
  id
) => ({
  type: UPDATE_ASSESSMENT_DATA,
  payload: { data, history, getAssessmentsData, id },
})

export const updateAssessmentSuccess = data => ({
  type: UPDATE_ASSESSMENT_SUCCESS,
  payload: data,
})

export const updateAssessmentFail = error => ({
  type: UPDATE_ASSESSMENT_FAIL,
  payload: error,
})

export const stepBack = id => ({
  type: STEP_BACK,
  payload: id,
})

export const clearAssessmentId = data => ({
  type: CLEAR_ASSESSMENT_ID,
  payload: data,
})
export const stepNext = id => ({
  type: STEP_NEXT,
  payload: id,
})

export const goToDashboard = history => ({
  type: GO_TO_DASHBOARD,
  payload: history,
})

export const cloneAssessment = (assessmentId) => ({
  type: CLONE_ASSESSMENT,
  payload: { assessmentId },
})

export const cloneAssessmentSuccess = data => ({
  type: CLONE_ASSESSMENT_SUCCESS,
  payload: data,
})

export const cloneAssessmentFail = error => ({
  type: CLONE_ASSESSMENT_FAIL,
  payload: error,
})

export const deleteAssessment = (id) => ({
  type: DELETE_ASSESSMENT,
  payload: { id },
})

export const deleteAssessmentSuccess = message => ({
  type: DELETE_ASSESSMENT_SUCCESS,
  payload: message,
})

export const deleteAssessmentFail = error => ({
  type: DELETE_ASSESSMENT_FAIL,
  payload: error,
})

export const createPatient = (data, history) => ({
  type: CREATE_PATIENT,
  payload: { data, history },
})

export const createPatientSuccess = data => ({
  type: CREATE_PATIENT_SUCCESS,
  payload: data,
})

export const createPatientFail = error => ({
  type: CREATE_PATIENT_FAIL,
  payload: error,
})

export const getPatientData = () => ({
  type: GET_PATIENT_DATA,
})

export const getPatientDataSuccess = data => ({
  type: GET_PATIENT_DATA_SUCCESS,
  payload: data,
})

export const getPatientDataFail = error => ({
  type: GET_PATIENT_DATA_FAIL,
  payload: error,
})

export const updatePatient = (data, history, getPatientData, patientId) => ({
  type: UPDATE_PATIENT,
  payload: { data, history, getPatientData, patientId },
})

export const updatePatientSuccess = data => ({
  type: UPDATE_PATIENT_SUCCESS,
  payload: data,
})

export const updatePatientFail = error => ({
  type: UPDATE_PATIENT_FAIL,
  payload: error,
})

export const deletePatient = (history, getPatientData, patientId) => ({
  type: DELETE_PATIENT,
  payload: { history, getPatientData, patientId },
})

export const deletePatientSuccess = message => ({
  type: DELETE_PATIENT_SUCCESS,
  payload: message,
})

export const deletePatientFail = error => ({
  type: DELETE_PATIENT_FAIL,
  payload: error,
})
